import { createSelector } from 'reselect'; // eslint-disable-line

// NOTE: Use these to make sure reference don't change
const emptyList = []; // eslint-disable-line
const emptyObject = {}; // eslint-disable-line

// eslint-disable-next-line
export const authenticatedSelector = ({ auth }) => auth.authenticated;
export const tokenSelector = ({ auth }) => auth.token;
export const userIdSelector = ({ auth }) => auth.userId;
export const userInfoSelector = ({ auth }) => auth.userInfo;

export const userSelector = createSelector(
    userIdSelector,
    userInfoSelector,
    (id, userInfo) => ({ id, ...userInfo }),
);




// WEBPACK FOOTER //
// ./src/common/selectors/auth.js